import { render } from "./MvtMovement.vue?vue&type=template&id=0f8b985e"
import script from "./MvtMovement.vue?vue&type=script&lang=js"
export * from "./MvtMovement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__